import * as React from 'react';
import { QuestionnaireDto } from '../../questionnaire/questionnaireTypes';
import { translation } from '../../../i18n';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import { EmployeeDto } from '../../user/userTypes';
import { defaultPageable, Pageable } from '../../../api/pageable';
import EmptyPage from '../../../components/emptyPage/EmptyPage';
import { getExternalActual } from '../questionnaireApi';
import { RouteComponentProps, withRouter } from 'react-router';
import { EXTERNAL_ACTUAL_ROUTE } from '../../../router/routes';
import { withQuestionnairePage } from '../../../router/Loaders';
import QuestionnaireList from '../../../components/questionnaire/unansweredQuestionnaire/QuestionnaireList';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
  currentEmployee: EmployeeDto;
}

type CombinedProps = RouteComponentProps & Props;

@observer
class ExternalActualList extends React.Component<CombinedProps> {

  @observable private pageAble: Pageable = defaultPageable();

  constructor(props: CombinedProps) {
    super(props);

    this.props.renderSearch(true);
  }

  public render() {
    return (
      <>
        {
          withQuestionnairePage(
            () =>
              getExternalActual({searchText: this.props.searchText.get()}, this.pageAble),
            'withPage' + this.pageAble.page + this.props.searchText,
            questionnairesPage =>
              <QuestionnaireList
                onClick={(id: number, _: QuestionnaireDto) => this.props.history.push(EXTERNAL_ACTUAL_ROUTE.externalActual(id).route)}
                handleChangePage={this.handleChangePage}
                questionnaires={questionnairesPage}
                emptyPage={
                  <EmptyPage
                    title={translation.t('historyComponent.external.title')}
                    message={translation.t('actualComponent.body')}
                    searchText={this.props.searchText.get()}
                    displayFab={false}/>
                }/>
          )

        }
      </>
    );
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
  };

}

export default withRouter(ExternalActualList);
